
import React, {useContext, useState} from 'react'
import {Auth} from "aws-amplify";
import {Link, useNavigate} from "react-router-dom";
import {Dialog, Transition} from '@headlessui/react'
import {Bars3Icon,  XMarkIcon,} from '@heroicons/react/24/outline'
import {PiPolygonLight   } from "react-icons/pi";
import {CiMap,CiPhone , CiFileOn, CiShop, CiLogout, CiInboxIn, CiMedicalClipboard, CiUser } from "react-icons/ci";
import {IoMdArrowDropright, IoMdArrowDropleft  } from "react-icons/io";
import logo from "#src/assets/logo.svg";
import {UserContext} from "#src/context/UserContext";
import {shortTagFromString} from "#src/helper/shortNameGenerator";
import {verifyPermissions} from "#src/helper/getProductSettingsHandler";
import {NotificationButton } from '#src/components/navigation/notificationButton';
import {ChangeCompany} from '#src/components/changeCompany';

import { CiFlag1,CiViewTimeline,CiFolderOn} from "react-icons/ci";



export const Navigation = () => {

    const {user, company, navigationOpen,setNavigationOpen, unreadNotifications} = useContext(UserContext);
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const navigate = useNavigate();
    const navigation = [];
    const creator = [];
    const hf = [];


    const settings = [
        { name: 'Hilfe', href: 'https://www.xplanung24.de/faq',  icon: CiPhone  },
        { name: 'Benutzer', href: '/user',  icon: CiUser  },
        { name: 'Company', href: '/',  icon: CiShop  },
        { name: 'Abmelden', href: '/',  icon: CiLogout  },
    ];

    if (user?.role === 'admin') {
        settings.splice(1, 0, { name: 'Account', href: '/company', icon: CiShop });
    }

    const handleClick = () => {
        let status = false;
        if(navigationOpen === null || navigationOpen === 0) {
            status = 1;
        } else {
            status = 0;
        }
        setNavigationOpen(status);
        localStorage.setItem('NavigationOpen', status);

    };


     if( verifyPermissions(company, "plan") === true) {
         navigation.push({ name: 'Pläne', href: '/plans',  icon: PiPolygonLight  });
     }

     if( verifyPermissions(company, "maps") === true) {
         navigation.push({ name: 'Karten',href: '/maps',  icon: CiMap });
     }

     if( verifyPermissions(company, "orders") === true) {
         navigation.push({ name: 'Aufträge',  href: '/orders',  icon: CiMedicalClipboard  });
     }

     if( verifyPermissions(company, "ordersTender") === true) {
         creator.push({ name: 'Angebote einholen', href: '/ordersTender',  icon: CiInboxIn    });
     }

     if( verifyPermissions(company, "ordersManagement") === true) {
         creator.push({ name: 'Auftragsmanagement',  href: '/ordersManagement',  icon: CiFileOn  });
     }


    if( verifyPermissions(company, "projects") === true) {
        hf.push({ name: 'Grundstücke', href: '/projects',  icon: CiViewTimeline    });
    }

    if( verifyPermissions(company, "documents") === true) {
        hf.push({ name: 'Dokumenten Hub', href: '/documents',  icon: CiFolderOn   });
    }


    return (
            <div>
                <Transition show={sidebarOpen}>
                    <Dialog open={sidebarOpen} onClose={setSidebarOpen} className="relative z-50 lg:hidden">
                        <Dialog.Backdrop
                            transition
                            className="fixed inset-0 bg-gray-900/80 z-40 transition-opacity duration-300 ease-linear data-[closed]:opacity-0"
                        />

                        <div className="fixed inset-0 flex">
                            <Dialog.Panel
                                transition
                                className="relative mr-16 border-r border-gray-500 flex w-full max-w-xs flex-1 transform transition duration-300 ease-in-out data-[closed]:-translate-x-full"
                            >

                                <Transition.Child>

                                </Transition.Child>


                                {/* Sidebar component, swap this element with another sidebar if you like */}
                                <div className="flex grow flex-col gap-y-5 overflow-y-auto bg-white px-6 pb-4">
                                    <div className={"flex"}>
                                        <div className=" w-16 duration-300 ease-in-out data-[closed]:opacity-0">
                                            <button type="button" onClick={() => setSidebarOpen(false)} className="mt-1.5 py-3 -ml-1  ">
                                                <span className="sr-only">Close sidebar</span>
                                                <XMarkIcon aria-hidden="true" className="h-7 w-7 text-gray-900" />
                                            </button>
                                        </div>
                                        <a href={"https://www.xplanung24.de"} target={"_blank"} className="flex h-16 shrink-0 items-center" rel="noreferrer">
                                            <img
                                                alt="XPLANUNG24"
                                                src={logo}
                                                className="h-7 w-auto"
                                            />
                                            <span className={"font-bold  lg:block pl-2.5 text-xl"}>PLANUNG24</span>
                                        </a>
                                    </div>
                                    <nav className="flex flex-1 flex-col">
                                        <div className="text-xs font-semibold h-6 leading-6 text-gray-600">{(navigationOpen === 0 && navigation.length > 0) ? "Planung":""}</div>
                                        <ul className="flex flex-1 flex-col ">
                                            <li>
                                                <ul className="-mx-2 space-y-2">
                                                    {navigation?.map((item) => (
                                                        <li key={item.name} title={item.name}>
                                                            <Link
                                                                to={item?.href}
                                                                onClick={() => {setSidebarOpen(false)}}
                                                                className={'text-gray-900 hover:bg-indigo-700 hover:text-white group flex gap-x-3 rounded-md p-2 text-sm leading-6'}
                                                            >
                                                                <item.icon
                                                                    aria-hidden="true"
                                                                    className={'text-gray-900 group-hover:text-white h-6 w-6 shrink-0'}
                                                                />
                                                                {item.name}
                                                            </Link >
                                                        </li>
                                                    ))}
                                                </ul>
                                            </li>
                                            <li>
                                                <div className="text-xs font-semibold h-6 leading-6 text-gray-600">{(navigationOpen === 0 && creator.length > 0) ? "Auftragsmanagement":""}</div>
                                                <ul className="-mx-2 mt-2 space-y-2">
                                                    {creator?.map((item) => (
                                                        <li key={item.name} title={item.name}>
                                                            <Link
                                                                to={item.href}
                                                                onClick={() => {setSidebarOpen(false)}}
                                                                className={'text-gray-900 hover:bg-indigo-700 hover:text-white group flex gap-x-3 rounded-md p-2 text-sm  leading-6'}
                                                            >
                                                                <item.icon
                                                                    aria-hidden="true"
                                                                    className={'text-gray-900 group-hover:text-white h-6 w-6 shrink-0'}
                                                                />
                                                                {item.name}
                                                            </Link >
                                                        </li>
                                                    ))}
                                                </ul>
                                            </li>
                                            <li>
                                                <div className="text-xs font-semibold h-6 leading-6 text-gray-600">{(navigationOpen === 0 && hf.length > 0) ? "Projektierung":""}</div>
                                                <ul className="-mx-2 mt-2 space-y-2">
                                                    {hf?.map((item) => (
                                                        <li key={item.name} title={item.name}>
                                                            <Link
                                                                to={item.href}
                                                                onClick={() => {setSidebarOpen(false)}}
                                                                className={'text-gray-900 hover:bg-indigo-700 hover:text-white group flex gap-x-3 rounded-md p-2 text-sm  leading-6'}
                                                            >
                                                                <item.icon
                                                                    aria-hidden="true"
                                                                    className={'text-gray-900 group-hover:text-white h-6 w-6 shrink-0'}
                                                                />
                                                                {item.name}
                                                            </Link >
                                                        </li>
                                                    ))}
                                                </ul>
                                            </li>
                                            <li className="mt-auto mb-2">
                                                <ul className="-mx-2 mt-2 space-y-2">
                                                    <NotificationButton  unreadNotifications={unreadNotifications} navigationOpen={0}/>
                                                    { settings?.map((item) => (
                                                        <li key={"users-"+item.name} title={item.name}>
                                                            {(item.name === "Abmelden") ? (
                                                                <button
                                                                    onClick={() => {
                                                                        Auth.signOut().then(() => navigate("/"))
                                                                            .catch(err => console.error('Error signing out user:', err));
                                                                    }}
                                                                    className={'text-gray-900 hover:bg-indigo-700 hover:text-white group flex gap-x-3 rounded-md p-2 text-sm leading-6'}
                                                                >
                                                                    <item.icon
                                                                        aria-hidden="true"
                                                                        className={'text-gray-900 group-hover:text-white h-6 w-6 shrink-0'}
                                                                    />
                                                                    {item.name}
                                                                </button>
                                                            ) : (
                                                                <Link
                                                                    to={item?.href}
                                                                    onClick={() => {setSidebarOpen(false)}}
                                                                    className={'text-gray-900 hover:bg-indigo-700 hover:text-white  group truncate flex gap-x-3 rounded-md p-2 text-sm leading-6'}
                                                                >
                                                                    {(typeof item?.text !== "undefined") ? (
                                                                        <React.Fragment>
                                                                            {(typeof user?.name !== "undefined") ? (
                                                                                <div className={'flex -mx-1 items-center'}>
                                                                                    <div className={" px-1.5 py-0.5 border border-gray-900 rounded-2xl  mr-2"}>{shortTagFromString?.(user?.name)}</div>
                                                                                    {user?.name}
                                                                                </div>
                                                                            ):(
                                                                                <div className={'flex -mx-1 items-center'}>
                                                                                    <item.icon
                                                                                        aria-hidden="true"
                                                                                        className={'text-gray-900 group-hover:text-white block pl-2 h-6 w-6 shrink-0'}
                                                                                    />
                                                                                    <>
                                                                                        {"Benutzer" }
                                                                                    </>
                                                                                </div>
                                                                            )}
                                                                        </React.Fragment>
                                                                    ) : (
                                                                        <>
                                                                            <item.icon
                                                                                aria-hidden="true"
                                                                                className={'text-gray-900 group-hover:text-white h-6 w-6 shrink-0'}
                                                                            />
                                                                            {item.name}
                                                                        </>
                                                                    )}

                                                                </Link>
                                                            )}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>
                            </Dialog.Panel>
                        </div>
                    </Dialog>
                </Transition>

                {/* Static sidebar for desktop */}
                <div className={(navigationOpen === 0) ? "hidden lg:fixed bg-white  lg:inset-y-0 lg:z-10 shadow-xl  lg:flex lg:w-60 lg:flex-col" :"hidden lg:fixed lg:inset-y-0 lg:z-10 shadow-xl  bg-white   lg:flex lg:w-[80px] lg:flex-col"}>

                    {/* Sidebar component, swap this element with another sidebar if you like */}
                    <div className="flex grow flex-col  gap-y-6  border-r  px-7 pt-[33px]">
                        <a href={"https://www.xplanung24.de"} target={"_blank"} className="flex -mt-1 relative items-center" rel="noreferrer">
                            <img
                                alt="XPLANUNG24"
                                src={logo}
                                className="h-8 w-auto"
                            />

                            {(navigationOpen === 0) ? (<span className={"font-bold  lg:block pl-2.5 text-2xl"}>PLANUNG24</span>):("")}
                        </a>
                            {(navigationOpen === 0) ? (<button className={"absolute p-1 border border-gray-500 bg-white rounded-2xl -right-[15px] "} onClick={() => {handleClick()}}><IoMdArrowDropleft  /></button>):(<button className={"absolute p-1 border border-gray-500 bg-white rounded-2xl -right-[15px] "} onClick={() => {handleClick()}}><IoMdArrowDropright   /></button>)}


                        <nav className="flex flex-1 flex-col">
                            <ul className="flex flex-1 flex-col gap-y-2">
                                <li>
                                    <div className="text-xs font-semibold h-6 leading-6 text-gray-600">{(navigationOpen === 0 && navigation.length > 0) ? "Planung":""}</div>
                                    <ul className="-mx-2 space-y-2">
                                        {navigation.map((item) => (
                                            <li key={item.name} title={item.name}>
                                                <Link
                                                    to={item?.href}
                                                    className={'text-gray-900 hover:bg-indigo-700 hover:text-white group flex gap-x-3 rounded-md p-2 text-sm leading-6'}
                                                >
                                                    <item.icon
                                                        aria-hidden="true"
                                                        className={'text-gray-900 group-hover:text-white h-6 w-6 shrink-0'}
                                                    />
                                                    {(navigationOpen === 0) ? item?.name:""}

                                                </Link >
                                            </li>
                                        ))}
                                    </ul>

                                    <ul className="-mx-2 mt-2 space-y-2">
                                        {creator.map((item) => (
                                            <li key={item.name} title={item.name}>
                                                <Link
                                                    to={item.href}
                                                    className={'text-gray-900 hover:bg-indigo-700 hover:text-white group flex gap-x-3 rounded-md p-2 text-sm  leading-6'}
                                                >
                                                    <item.icon
                                                        aria-hidden="true"
                                                        className={'text-gray-900 group-hover:text-white h-6 w-6 shrink-0'}
                                                    />
                                                    {(navigationOpen === 0) ? item.name:""}
                                                </Link >
                                            </li>
                                        ))}
                                    </ul>
                                </li>
                                <li>
                                    <div className="text-xs font-semibold h-6 leading-6 text-gray-600">{(navigationOpen === 0 && hf.length > 0) ? "Projektierung":""}</div>
                                    <ul className="-mx-2 mt-2 space-y-2">
                                        {hf.map((item) => (
                                            <li key={item.name} title={item.name}>
                                                <Link
                                                    to={item.href}
                                                    className={'text-gray-900 hover:bg-indigo-700 hover:text-white group flex gap-x-3 rounded-md p-2 text-sm  leading-6'}
                                                >
                                                    <item.icon
                                                        aria-hidden="true"
                                                        className={'text-gray-900 group-hover:text-white h-6 w-6 shrink-0'}
                                                    />
                                                    {(navigationOpen === 0) ? item.name:""}
                                                </Link >
                                            </li>
                                        ))}
                                    </ul>
                                </li>
                                <li className="mt-auto mb-2">
                                    <ul className="-mx-2 mt-2 space-y-2">
                                        <NotificationButton unreadNotifications={unreadNotifications} navigationOpen={navigationOpen}/>
                                        {settings.map((item) => (
                                            <li key={"users-"+item.name} title={item.name}>

                                                {(item.name === "Abmelden") ? (
                                                    <button
                                                        onClick={() => {
                                                            Auth.signOut().then(() => navigate("/"))
                                                                .catch(err => console.error('Error signing out user:', err));
                                                        }}
                                                        className={'text-gray-900 hover:bg-indigo-700 hover:text-white group flex gap-x-3 rounded-md p-2 text-sm leading-6 -ml-1'}
                                                    >
                                                        <item.icon
                                                            aria-hidden="true"
                                                            className={'text-gray-900 group-hover:text-white h-6 w-6 shrink-0'}
                                                        />
                                                        {(navigationOpen === 0) ? item.name:""}
                                                    </button>
                                                ) : (item.name === "Company") ? (
                                                    <div
                                                        className={`text-gray-900 flex items-center gap-x-2 rounded-md p-1 text-sm leading-6 -ml-1`}
                                                    >
                                                        <div className='ml-[1px]'>
                                                            <ChangeCompany />
                                                        </div>
                                                        {(navigationOpen === 0) && user.myCompanies?.find(company => company.target_id === user.companyId)?.company_name}
                                                    </div>
                                                ) : (
                                                    <Link
                                                        to={item?.href}
                                                        className={'text-gray-900 hover:bg-indigo-700 hover:text-white group truncate flex gap-x-3 rounded-md p-2 text-sm leading-6 -ml-0.5'}
                                                    >

                                                        {(typeof item?.text !== "undefined") ? (
                                                            <>
                                                                {(typeof user?.name !== "undefined") ? (
                                                                    <div className={'flex items-center'}>
                                                                        <div className={" px-1.5 py-0.5 border rounded-2xl border-gray-900  mr-2"}>{shortTagFromString?.(user?.name)}</div>
                                                                        {(navigationOpen === 0) ? user?.name:""}
                                                                    </div>
                                                                ):(
                                                                    <div className={'flex items-center'}>
                                                                        <item.icon
                                                                            aria-hidden="true"
                                                                            className={`text-gray-900 group-hover:text-white block h-6 w-6 mr-3 shrink-0`}
                                                                        />
                                                                        <>
                                                                            {(navigationOpen === 0) ? "Benutzer":""}
                                                                        </>
                                                                    </div>
                                                                )}
                                                            </>
                                                        ) : (
                                                            <>
                                                                <item.icon
                                                                    aria-hidden="true"
                                                                    className={`text-gray-900 group-hover:text-white h-6 w-6 shrink-0`}
                                                                />
                                                                {(navigationOpen === 0) ? item.name:""}
                                                            </>
                                                        )}

                                                    </Link>
                                                )}
                                            </li>
                                        ))}
                                    </ul>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
                <div className="sticky top-0 flex items-center gap-x-6 px-4 py-4 shadow-sm sm:px-6 lg:hidden">
                    <button type="button" onClick={() => setSidebarOpen(true)} className="-m-2.5 p-2.5 text-gray-900 lg:hidden">
                        <span className="sr-only">Open sidebar</span>
                        <Bars3Icon aria-hidden="true" className="h-6 w-6" />
                    </button>

                    <div className={"flex"}>
                        <a href={"https://www.xplanung24.de"} target={"_blank"} className="flex mt-1 relative items-center" rel="noreferrer">
                            <img
                                alt="XPLANUNG24"
                                src={logo}
                                className="h-7 w-auto"
                            />
                            <span className={"font-bold  lg:block pl-2.5 text-xl"}>PLANUNG24</span>
                        </a>
                    </div>

                </div>

            </div>
    )
}
